/** Campaign attribution storage keys and limits (Milestone 27). */

export const ATTRIBUTION_STORAGE_KEYS = {
  FIRST_TOUCH: "automap_attribution_first_touch",
  LAST_TOUCH: "automap_attribution_last_touch",
  SESSION: "automap_attribution_session",
  VISITOR_ID: "automap_visitor_id",
  SESSION_ID: "automap_session_id",
  CONVERSION_PATH: "automap_attribution_conversion_path",
  LANDING: "automap_attribution_landing",
};

export const ATTRIBUTION_LIMITS = {
  SESSION_INACTIVITY_MS: 30 * 60 * 1000,
  CONTEXT_RETENTION_MS: 30 * 24 * 60 * 60 * 1000,
  MAX_CONVERSION_PATH: 20,
  MAX_UTM_LENGTH: 256,
};

export const CLICK_ID_PARAMS = ["gclid", "fbclid", "ttclid", "msclkid"];

export const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
